'use client'

import React from 'react'
import { cn } from '@/lib/ui/utils'
import { openPrivacyCenter } from '@/services/components/strategies/privacy/tcf'

export interface PrivacyCenterClientProps {
  label: string
  className?: string
  /** Server-rendered children passed from the server wrapper */
  serverChildren?: React.ReactNode
}

/**
 * Keep interactive content out of <button> to avoid nested interactive controls.
 * Render the button and any nested items as siblings.
 */
const PrivacyCenterClient: React.FC<PrivacyCenterClientProps> = ({
  label,
  className,
  serverChildren,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    openPrivacyCenter()
  }

  return (
    <div className={cn('inline-flex flex-col gap-2', className)}>
      <button
        type="button"
        onClick={handleClick}
        className="py-1"
        aria-haspopup="dialog"
        aria-label={label}
        data-cy="privacy-center-btn"
      >
        {label}
      </button>

      {/* Any items the server pre-rendered (via ComponentFactory) */}
      {serverChildren}
    </div>
  )
}

export default PrivacyCenterClient
